import { render, staticRenderFns } from "./banner-m.vue?vue&type=template&id=185e3de4&scoped=true&"
import script from "./banner-m.vue?vue&type=script&lang=js&"
export * from "./banner-m.vue?vue&type=script&lang=js&"
import style0 from "./banner-m.vue?vue&type=style&index=0&id=185e3de4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185e3de4",
  null
  
)

export default component.exports